// ui/EmptyState — an empty list/panel says what to do next (Design Standard v1).
// Unknown is never 0: render this (or "—") when data is missing, not a zero.
import React from 'react';
import './ds.css';

export default function EmptyState({ icon = null, title, body, action = null, className = '' }) {
  return (
    <div className={`ds-empty ${className}`} role="status">
      {icon ? <div className="ds-empty__icon" aria-hidden="true">{icon}</div> : null}
      {title ? <p className="ds-empty__title">{title}</p> : null}
      {body ? <p className="ds-empty__body">{body}</p> : null}
      {action ? <div className="ds-empty__action">{action}</div> : null}
    </div>
  );
}
